import React, { useState, useEffect } from "react";
import LeadsCounter from "../LeadsCounter/LeadsCounter";
import LeadsInfoTable from "../LeadsInfoTable/LeadsInfotable";
import { connect } from "react-redux";
import { leadsData } from "../../../actions/feedActions";
import { getLeadData } from "../../../actions/emActions";

function Leads(props) {
  const [allLeads, setallLeads] = useState("");
  const [myLeads, setmyLeads] = useState("");
  const [reservedLeads, setreservedLeads] = useState("");
  const [leadsInfo, setleadsInfo] = useState("");
  const [mapoverLeads, setmapoverLeads] = useState([]);
  const [loggedUserId, setloggedUserId] = useState("");
  const [myLeadsArray, setmyLeadsArray] = useState([]);
  const [reservedArray, setreservedArray] = useState([]);
  const [faqData, setfaqData] = useState([]);
  const [convertedLeads, setconvertedLeads] = useState([]);
  const [convertedLeadsCount, setconvertedLeadsCount] = useState("");
  const [availableLeads, setavailableLeads] = useState("");
  const [availableDemoStatus, setavailableDemoStatus] = useState([]);
  const [isLoading, setisLoading] = useState(true);

  if (props.leadsInfo !== leadsInfo) {
    const { leadsInfo } = props;
    setmyLeads(leadsInfo.myLeads.myLeadsCount);
    setallLeads(leadsInfo.overAllleads.leadsCount);
    setreservedLeads(leadsInfo.reservedLeads.reservedLeadsCount);
    setmapoverLeads(leadsInfo.overAllleads.leads);
    setavailableDemoStatus(leadsInfo.overAllleads.demo_statuses);
    setmyLeadsArray(leadsInfo.myLeads.myLeads);
    setreservedArray(leadsInfo.reservedLeads.reservedLeads);
    setfaqData(leadsInfo.myLeads.faq_data);
    setconvertedLeads(leadsInfo.convertedLeads.convertedLeads);
    setconvertedLeadsCount(leadsInfo.convertedLeads.convertedLeadsCount)
    setavailableLeads(leadsInfo.availableLeads);
    setleadsInfo(leadsInfo);
  }

  useEffect(() => {
    setisLoading(true);
    var EMData = JSON.parse(localStorage.getItem("loginData"));
    if (EMData != null) {
      setloggedUserId(EMData.user.id);
      props
        .getLeadData(EMData.user.id)
        .then((res) => {
          console.log("LEAD DATA FROM API", res);
          setisLoading(false);
        })
        .catch((err) => {
        });
    }
  }, []);
  return isLoading ? (
    <div className="row">
      <div className="col-md-12 text-center">
        <div class="spinner-border text-warning" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  ) : (
      <React.Fragment>
        <LeadsCounter
          allLeads={allLeads}
          myLeads={myLeads}
          reservedLeads={reservedLeads}
          convertedLeads={convertedLeadsCount}
          availableLeads={availableLeads}
        />
        <LeadsInfoTable
          availableDemoStatus={availableDemoStatus}
          mapoverLeads={mapoverLeads}
          loggedUserId={loggedUserId}
          myLeadsArray={myLeadsArray}
          reservedArray={reservedArray}
          convertedLeads={convertedLeads}
          faqData={faqData}
          allLeads={allLeads}
        />
      </React.Fragment>
    );
}

function mapStateToProps(state) {
  return {
    leadsInfo: state.emReducer.emLeadsData,
  };
}

export default connect(mapStateToProps, { leadsData, getLeadData })(Leads);
